module.exports = __webpack_public_path__ + "static/Gilroy-Bold-b381c2abd2972024a6a7e3d882208d9b.ttf";